import { render, staticRenderFns } from "./OrdersPage.vue?vue&type=template&id=df77bb28&scoped=true"
import script from "./OrdersPage.vue?vue&type=script&lang=js"
export * from "./OrdersPage.vue?vue&type=script&lang=js"
import style0 from "./OrdersPage.vue?vue&type=style&index=0&id=df77bb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df77bb28",
  null
  
)

export default component.exports